// 尺寸map
interface StyleMapValue {
  styleName: string;
  size: {
    width: number;
    height: number;
  };
}
interface SizeMapValue {
  width: number;
  height: number;
}
export const styleMap = new Map<number, StyleMapValue>([
  [1, { styleName: '2*2', size: { width: 440, height: 440 } }],
  [2, { styleName: '4*2', size: { width: 948, height: 440 } }],
  [3, { styleName: '4*1', size: { width: 440, height: 440 } }], // 宽高待定
  [4, { styleName: '4*4', size: { width: 948, height: 1000 } }],
  [5, { styleName: '1*2', size: { width: 186, height: 440 } }],
  [6, { styleName: '2*1', size: { width: 440, height: 160 } }],
  [7, { styleName: '2*3', size: { width: 440, height: 720 } }],
]);

export const sizeMap = new Map<string, SizeMapValue>([
  ['2x2', { width: 440, height: 440 }],
  ['4x2', { width: 948, height: 440 }],
  ['4x1', { width: 440, height: 440 }], // 宽高待定
  ['4x4', { width: 948, height: 1000 }],
  ['1x2', { width: 186, height: 440 }],
  ['2x1', { width: 440, height: 160 }],
  ['2x3', { width: 440, height: 720 }],
]);

export const STORE_OFFLINE_CODE: number = 2;
export const statusMap = new Map([
  [1, 'unready'], //(1, "待填写")
  [2, 'ready'], //(2, "已填写")
  [3, 'under-review'], //(3,"审核中"),
  [4, 'published'], //(4,"已发布"),
  [5, 'unpass'], //(5, "未通过"),
  [0, 'tokeoff'], //(0,"下架"),
]);

export const stateOption = new Map<number, string>([
  [0, '待走查'],
  [1, '通过'],
  [2, '不通过'],
  [3, '终止'],
]);

/**
 *  TO_ADD(0, "待新增"),
    ADDED_TO_APPROVE(2, "新增应用待审核"),
    UPDATED_TO_APPROVE(4, "更新应用待审核"),
    INFO_CHANGE_TO_APPROVE(5, "信息变更待审核"),
    ONLINE(200, "上架"),
    OFFLINE(300, "下架"),
    ADDED_NOT_APPROVED(201, "新增应用审核未通过"),
    UPDATED_NOT_APPROVED(202, "更新应用审核未通过"),
    INFO_CHANGE_NOT_APPROVED(203, "信息变更审核未通过"),
    INFO_CHANGE_TEST_FAILED(208, "信息变更应用测试未通过"),
    ADDED_TO_TEST(301, "新增应用等待测试"),
    ADDED_TEST_FAILED(302, "新增应用测试未通过"),
    UPDATED_TO_TEST(304, "更新应用等待测试"),
    UPDATED_TEST_FAILED(305, "更新应用测试不通过"),
    OFFLINE_TO_APPROVE(306, "上架应用下架申请审核中"),
    OFFLINE_NOT_APPROVED(308, "上架应用下架申请审核中"),
    BLOCKLIST(1000, "进入黑名单的应用"),
 */
//  商店-陈治文
export const appStatusMap = new Map<number, string>([
  [0, '未上架'], // 待新增
  [2, '审核中'], // 新增应用待审核
  [4, '审核中'], // 更新应用待审核
  [5, '审核中'], // 信息变更待审核
  [200, '上架'], // 已上架
  [300, '未上架'], // 下架
  [201, '未上架'], // 新增应用审核未通过
  [202, '未上架'], // 更新应用审核未通过
  [203, '未上架'], // 信息变更审核未通过
  [208, '未上架'], // 信息变更应用测试未通过
  [301, '审核中'], // 新增应用等待测试
  [302, '未上架'], // 新增应用测试未通过
  [304, '审核中'], // 更新应用等待测试
  [305, '未上架'], // 更新应用测试不通过
  [306, '上架'], // 上架应用下架申请审核中
  [308, '上架'], // 上架应用下架申请审核中
  [1000, '上架'], // 进入黑名单的应用
]);
// 多语言
export const ZHCN_CODE: string = 'zh_CN';
export const ZHTW_CODE: string = 'zh_TW';
export const BOCN_CODE: string = 'bo_CN';
export const UGCN_CODE: string = 'ug_CN';
export const languageMap = new Map<string, string>([
  ['ar_EG', 'Arabic(Egypt)'],
  ['as_IN', 'Assamese(India)'],
  ['az_AZ', 'Azerbaijani(Azerbaijan)'],
  ['be_BY', 'Belarusian(Belarus)'],
  ['bg_BG', 'Bulgarian(Bulgaria)'],
  ['bn_BD', 'Bengali(Bangladesh)'],
  ['bn_IN', 'Bengali(India)'],
  ['bo_CN', 'Tibetan(China)'],
  ['bs_BA', 'Bosnian(Bosnia and Herzegovina)'],
  ['ca_ES', 'Catalan(Spain)'],
  ['cs_CZ', 'Czech(Czech Republic)'],
  ['da_DK', 'Danish(Denmark)'],
  ['de_DE', 'German(Germany)'],
  ['el_GR', 'Greek(Greece)'],
  ['en_GB', 'English(United Kingdom)'],
  ['en_IN', 'English(India)'],
  ['en_US', 'English(United States)'],
  ['es_ES', 'Spanish(Spain)'],
  ['es_US', 'Spanish(United States)'],
  ['et_EE', 'Estonian(Estonia)'],
  ['eu_ES', 'Basque(Spain)'],
  ['fa_IR', 'Persian(Iran)'],
  ['fi_FI', 'Finnish(Finland)'],
  ['fr_FR', 'French(France)'],
  ['gl_ES', 'Gallegan(Spain)'],
  ['gu_IN', 'Gujarati(India)'],
  ['ha_NG', 'Hausa(Nigeria)'],
  ['hi_IN', 'Hindi(India)'],
  ['hr_HR', 'Croatian(Croatia)'],
  ['hu_HU', 'Hungarian(Hungary)'],
  ['hy_AM', 'Armenian(Armenia)'],
  ['in_ID', 'Indonesian(Indonesia)'],
  ['it_IT', 'Italian(Italy)'],
  ['iw_IL', 'Hebrew(Israel)'],
  ['ja_JP', 'Japanese(Japan)'],
  ['ka_GE', 'Georgian(Georgia)'],
  ['kk_KZ', 'Kazakh(Kazakhstan)'],
  ['km_KH', 'Khmer(Cambodia)'],
  ['kn_IN', 'Kannada(India)'],
  ['ko_KR', 'Korean(South Korea)'],
  ['lo_LA', 'Lao(Laos)'],
  ['lt_LT', 'Lithuanian(Lithuania)'],
  ['lv_LV', 'Latvian(Latvia)'],
  ['mk_MK', 'Macedonian(Macedonia)'],
  ['ml_IN', 'Malayalam(India)'],
  ['mr_IN', 'Marathi(India)'],
  ['ms_MY', 'Malay(Malaysia)'],
  ['mt_MT', 'Maltese(Malta)'],
  ['my_MM', 'Burmese(Myanmar)'],
  ['nb_NO', 'Norwegian Bokmål(Norway)'],
  ['ne_IN', 'Nepali(India)'],
  ['ne_NP', 'Nepali(Nepal)'],
  ['nl_NL', 'Dutch(Netherlands)'],
  ['or_IN', 'Oriya(India)'],
  ['pa_IN', 'Panjabi(India)'],
  ['pl_PL', 'Polish(Poland)'],
  ['pt_BR', 'Portuguese(Brazil)'],
  ['pt_PT', 'Portuguese(Portugal)'],
  ['ro_RO', 'Romanian(Romania)'],
  ['ru_RU', 'Russian(Russia)'],
  ['sk_SK', 'Slovak(Slovakia)'],
  ['sl_SI', 'Slovenian(Slovenia)'],
  ['sq_AL', 'Albanian(Albania)'],
  ['sr_RS', 'Serbian(Serbia)'],
  ['sv_SE', 'Swedish(Sweden)'],
  ['ta_IN', 'Tamil(India)'],
  ['te_IN', 'Telugu(India)'],
  ['th_TH', 'Thai(Thailand)'],
  ['tr_TR', 'Turkish(Turkey)'],
  ['ug_CN', 'Uighur(China)'],
  ['uk_UA', 'Ukrainian(Ukraine)'],
  ['ur_IN', 'Urdu(India)'],
  ['uz_UZ', 'Uzbek(Uzbekistan)'],
  ['vi_VN', 'Vietnamese(Vietnam)'],
  ['zh_CN', 'Chinese(China)'],
  ['zh_TW', 'Traditional Chinese(Taiwan)'],
]);

export const widgetListTemp = [
  {
    id: 4, // 小部件ID
    regionList: [], //小部件地区列表
    name: 'Date', // 小部件名称
    desc: '', // 小部件说明
    size: '4x4', // 小部件风格
    widgetId: 'bb9378e2d6a52b617ac38ca84ce84dac', //小部件编号
    status: 1, //当前状态  1-待填写 2-已填写 3-审核中 4-已发布 5-未通过 0-下架
    updateStatus: 1,
    lightModeUrl: '',
    darkModeUrl: '',
    multiLangList: [
      //多语言支持
      {
        langCode: 'en_US',
        widgetLangItem: {
          dispAppName: '',
          widgetName: 'Date',
          widgetDesc: '',
        },
      },
    ],
    appVers: [
      // 小部件上线的APP版本
      {
        verCode: 12050500,
        verName: '12.5.5',
      },
    ],
    rejects: [
      {
        state: 2,
        reason: '测试不通过',
        fileUrl: '123321',
        dateTime: 1651217861000,
        remark: '测试不通过',
      },
    ],
    new: false,
  },
  {
    id: 4, // 小部件ID
    regionList: [], //小部件地区列表
    name: 'Date', // 小部件名称
    desc: '', // 小部件说明
    size: '2x4', // 小部件风格
    widgetId: 'bb9378e2d6a52b617ac38ca84ce84dac', //小部件编号
    status: 2, //当前状态  1-待填写 2-已填写 3-审核中 4-已发布 5-未通过 0-下架
    lightModeUrl: '',
    updateStatus: 1,
    darkModeUrl: '',
    multiLangList: [
      //多语言支持
      {
        langCode: 'en_US',
        widgetLangItem: {
          dispAppName: '',
          widgetName: 'Date',
          widgetDesc: '',
        },
      },
    ],
    appVers: [
      // 小部件上线的APP版本
      {
        verCode: 12050500,
        verName: '12.6.6',
      },
    ],
    rejects: [
      {
        state: 2,
        reason: '测试不通过',
        fileUrl: '123321',
        dateTime: 1651217861000,
        remark: '测试不通过',
      },
    ],
    new: false,
  },
  {
    id: 5, // 小部件ID
    regionList: [], //小部件地区列表
    name: 'Date', // 小部件名称
    desc: '', // 小部件说明
    size: '2x2', // 小部件风格
    widgetId: 'bb9378e2d6a52b617ac38ca84ce84dac', //小部件编号
    status: 3, //当前状态  1-待填写 2-已填写 3-审核中 4-已发布 5-未通过 0-下架
    lightModeUrl: '',
    darkModeUrl: '',
    updateStatus: 1,
    multiLangList: [
      //多语言支持
      {
        langCode: 'en_US',
        widgetLangItem: {
          dispAppName: '',
          widgetName: 'Date',
          widgetDesc: '',
        },
      },
    ],
    appVers: [
      // 小部件上线的APP版本
      {
        verCode: 12050500,
        verName: '12.5.5',
      },
    ],
    rejects: [
      {
        state: 2,
        reason: '测试不通过',
        fileUrl: '123321',
        dateTime: 1651217861000,
        remark: '测试不通过',
      },
    ],
    new: false,
  },
  {
    id: 8, // 小部件ID
    regionList: [], //小部件地区列表
    name: 'Date', // 小部件名称
    desc: '', // 小部件说明
    size: '4x4', // 小部件风格
    widgetId: 'bb9378e2d6a52b617ac38ca84ce84dac', //小部件编号
    status: 4, //当前状态  1-待填写 2-已填写 3-审核中 4-已发布 5-未通过 0-下架
    lightModeUrl: '',
    darkModeUrl: '',
    updateStatus: 1,
    multiLangList: [
      //多语言支持
      {
        langCode: 'en_US',
        widgetLangItem: {
          dispAppName: '',
          widgetName: 'Date',
          widgetDesc: '',
        },
      },
    ],
    appVers: [
      // 小部件上线的APP版本
      {
        verCode: 12050500,
        verName: '12.8.8',
      },
      {
        verCode: 1208080,
        verName: '12.17.0',
      },
    ],
    rejects: [
      {
        state: 2,
        reason: '测试不通过',
        fileUrl: '123321',
        dateTime: 1651217861000,
        remark: '测试不通过',
      },
    ],
    new: false,
  },
  {
    id: 9, // 小部件ID
    regionList: [], //小部件地区列表
    name: 'Date', // 小部件名称
    desc: '', // 小部件说明
    size: '4x4', // 小部件风格
    widgetId: 'bb9378e2d6a52b617ac38ca84ce84dac', //小部件编号
    status: 5, //当前状态  1-待填写 2-已填写 3-审核中 4-已发布 5-未通过 0-下架
    lightModeUrl: '',
    updateStatus: 1,
    darkModeUrl: '',
    multiLangList: [
      //多语言支持
      {
        langCode: 'en_US',
        widgetLangItem: {
          dispAppName: '',
          widgetName: 'Date',
          widgetDesc: '',
        },
      },
    ],
    appVers: [
      // 小部件上线的APP版本
      {
        verCode: 12050500,
        verName: '12.5.5',
      },
    ],
    rejects: [
      {
        state: 2,
        reason: '测试不通过',
        fileUrl: '123321',
        dateTime: 1651217861000,
        remark: '测试不通过',
      },
    ],
    new: false,
  },
  {
    id: 80, // 小部件ID
    regionList: [], //小部件地区列表
    name: 'Date', // 小部件名称
    desc: '', // 小部件说明
    size: '4x2', // 小部件风格
    widgetId: 'bb9378e2d6a52b617ac38ca84ce84dac', //小部件编号
    status: 0, //当前状态  1-待填写 2-已填写 3-审核中 4-已发布 5-未通过 0-下架
    lightModeUrl: '',
    updateStatus: 1,
    darkModeUrl: '',
    multiLangList: [
      //多语言支持
      {
        langCode: 'en_US',
        widgetLangItem: {
          dispAppName: '',
          widgetName: 'Date',
          widgetDesc: '',
        },
      },
    ],
    appVers: [
      // 小部件上线的APP版本
      {
        verCode: 12050500,
        verName: '12.10.5',
      },
    ],
    rejects: [
      {
        state: 2,
        reason: '测试不通过',
        fileUrl: '123321',
        dateTime: 1651217861000,
        remark: '测试不通过',
      },
    ],
    new: false,
  },
];
// 测试数据-后期删除
export const defaultTestListData = [
  {
    code: 'wd_0220210528102533042749',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '体育赛事',
    desc: '',
    mark:
      'com.miui.personalassistant.service.sports.widget.SportsWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 4,
    added: 0,
    sort: 1,
    status: 0,
    createTime: '2021-06-19T03:20:01.000+00:00',
    updateTime: '2021-06-19T05:56:42.000+00:00',
  },
  {
    code: 'wd_0220210528102533013705',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '股票行情',
    desc: '',
    mark:
      'com.miui.personalassistant.service.stock.widget.SmallStockWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 1,
    added: 0,
    sort: 2,
    status: 2,
    createTime: '2021-06-19T03:20:01.000+00:00',
    updateTime: '2021-06-19T05:56:42.000+00:00',
  },
  {
    code: 'wd_0220210528102533025516',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '股票行情',
    desc: '',
    mark:
      'com.miui.personalassistant.service.stock.widget.MediumStockWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 2,
    added: 0,
    sort: 2,
    status: 7,
    createTime: '2021-06-19T03:20:01.000+00:00',
    updateTime: '2021-06-19T05:56:42.000+00:00',
  },
  {
    code: 'wd_0220210528102533045260',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '股票行情',
    desc: '',
    mark:
      'com.miui.personalassistant.service.stock.widget.LargeStockWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 4,
    added: 0,
    sort: 2,
    status: 12,
    createTime: '2021-06-19T03:20:01.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_0220210528102533045262',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '股票行情',
    desc: '',
    mark:
      'com.miui.personalassistant.service.stock.widget.LargeStockWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 4,
    added: 0,
    sort: 2,
    status: 8,
    createTime: '2021-06-19T03:20:01.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_0220210528102533020316',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '疫情服务',
    desc: '',
    mark: 'com.miui.personalassistant.service.covid.CovidWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 2,
    added: 0,
    sort: 5,
    status: 0,
    createTime: '2021-06-19T03:20:01.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_0220210619120258014385',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '快捷功能',
    desc: '',
    mark:
      'com.miui.personalassistant.service.shortcut.widget.shortcut.SmallShortcutWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 1,
    added: 0,
    sort: 3,
    status: 1,
    createTime: '2021-06-19T04:02:58.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_0220210619120258026544',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '快捷功能',
    desc: '',
    mark:
      'com.miui.personalassistant.service.shortcut.widget.shortcut.MediumShortcutWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 2,
    added: 0,
    sort: 3,
    status: 1,
    createTime: '2021-06-19T04:02:58.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_0220210619120258014384',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '有道云',
    desc: '',
    mark:
      'com.miui.personalassistant.service.shortcut.widget.shortcut.SmallShortcutWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 1,
    added: 0,
    sort: 3,
    status: 8,
    createTime: '2021-06-19T04:02:58.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_022021061912028026544',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '有道云',
    desc: '',
    mark:
      'com.miui.personalassistant.service.shortcut.widget.shortcut.MediumShortcutWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 2,
    added: 0,
    sort: 3,
    status: 8,
    createTime: '2021-06-19T04:02:58.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_022021061912028026544',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '有道云',
    desc: '',
    mark:
      'com.miui.personalassistant.service.shortcut.widget.shortcut.MediumShortcutWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 2,
    added: 0,
    sort: 3,
    status: 11,
    statusDesc: {
      reason: 'asdfasdfas',
      amendments: 'afasdfsaf',
    },
    createTime: '2021-06-19T04:02:58.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_0220210619120258010535',
    abilityCode: 'wd_0120210528102533933988',
    abilityVersion: 13,
    name: '应用建议',
    desc: '',
    mark:
      'com.miui.personalassistant.service.shortcut.widget.smartshortcut.SmallSmartShortcutWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 1,
    added: 0,
    sort: 4,
    status: 0,
    createTime: '2021-06-19T04:02:58.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
  {
    code: 'wd_022021061912025',
    abilityCode: 'wd_01202105281533933988',
    abilityVersion: 13,
    name: '测试一',
    desc: '',
    mark:
      'com.miui.personalassistant.service.shortcut.widget.smartshortcut.SmallSmartShortcutWidgetProvider',
    type: 1,
    widgetImplInfo: {
      heightSize: 160,
      modeList: [
        {
          darkMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          lightMode: {
            previewUrl:
              'https://cdn.cnbj1.fds.api.mi-img.com/assistant-models/32725a85-efe6-4cb3-b605-0f5b069a20e3.png',
            url:
              'https://cdn.cnbj1.fds.api.mi-img.com/mag-developer/30k-440-440.jpg?f=webp',
          },
          desc: '查看本地时间',
          language: 'zh-CN',
        },
      ],
      terminalList: [{ client: 'phone', deviceList: ['abc'] }],
      widthSize: 160,
    },
    style: 1,
    added: 0,
    sort: 6,
    status: 8,
    createTime: '2021-06-19T04:02:58.000+00:00',
    updateTime: '2021-06-19T05:56:43.000+00:00',
  },
];
